module.exports = __webpack_public_path__ + "static/17-mission2-final-terms-edc131269465f9c527d791e0028cb437.png";